// extracted by mini-css-extract-plugin
export default {"clearfix":"ArrowBackButton_clearfix__bDu0V","buttonContainer":"ArrowBackButton_buttonContainer__mJJeC"};